<template>
  <div class="index">
    <v-scale-screen width="1920" height="1080">
      <div class="comtain">
        <div v-show="load" style="width: 100%; height: 100%">
          <dv-loading>Loading...</dv-loading>
        </div>
        <div>
          <div class="top">
            <topPage @change="tabChange($event)" :chooseTabId="tabId"></topPage>
          </div>
          <!-- 首页 -->
          <div class="indexPage" v-show="tabId == 0" @click="clearTime">
            <indexPage @change="tabChange($event)"></indexPage>
          </div>
        </div>
      </div>
    </v-scale-screen>
  </div>
</template>
<style>
@import url(../index/index.less);
@import url(../../style/base.less);
.absolute {
  position: absolute;
  bottom: -60px;
}
</style>
<script>
//首页
import indexPage from "../indexPage/indexPage";
export default {
  components: {
    indexPage,
  },
  data() {
    return {
      load: true,
      timer: null,
      tabId: 0,
      value: 2,
      tabTimer: null,
      checkTimer: null,
    };
  },
  created() {
    // 每次进入界面时，先清除之前的所有定时器，然后启动新的定时器
    clearInterval(this.timer);
    this.timer = null;
    this.setTimer();
    this.setTabTime();
  },
  destroyed() {
    // 每次离开当前界面时，清除定时器
    clearInterval(this.timer);
    this.timer = null;
  },
  mounted() {},
  methods: {
    //设置定时器
    setTimer() {
      if (this.load) {
        this.timer = setInterval(() => {
          this.load = false;
        }, 1000);
      }
    },
    tabChange(e) {
      this.tabId = e;
    },
    //页面轮播
    setTabTime() {
      this.tabTimer = setInterval(this.changeTabTime, 30000);
    },
    changeTabTime() {
      // if (this.tabId == 5) {
      //   this.tabId = 1;
      // } else {
      //   this.tabId++;
      // }
    },
    clearTime() {
      clearInterval(this.tabTimer);
      this.tabTimer = null;
      clearInterval(this.checkTimer);
      this.checkTimer = null;
      this.checkTimer = setInterval(this.setTabTime, 300000);
    },
  },
};
</script>